import React from 'react';
export default function UnknownBlock(props) {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
  return /*#__PURE__*/React.createElement("div", {
    className: "UnknownBlock"
  }, props.children);
}